import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'dateDiff',
})
export class DateDiffPipe implements PipeTransform {
  transform(value: any, ...args: any[]): any {
    if (!value) {
      return 'No date provided';
    }
    const endDateTime = new Date(value);
    const today = new Date();
    const timeDiff = Math.abs(today.getTime() - endDateTime.getTime());
    const diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));

    if (diffDays > 1) {
      return diffDays + ' days';
    }
    if (diffDays <= 1) {
      const pad = (n, z = 2) => ('00' + n).slice(-z);

      return (
        // tslint:disable-next-line: no-bitwise
        pad((timeDiff / 3.6e6) | 0) +
        'h:' +
        // tslint:disable-next-line: no-bitwise
        pad(((timeDiff % 3.6e6) / 6e4) | 0) +
        'm:' +
        // tslint:disable-next-line: no-bitwise
        pad(((timeDiff % 6e4) / 1000) | 0) +
        's'
      );
    }
  }
}
